// extracted by mini-css-extract-plugin
export var columnList = "_fc-0";